import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

declare var $: any;

@Component({
  selector: 'app-puesto-votacion',
  templateUrl: './puesto-votacion.component.html',
  styleUrls: ['./puesto-votacion.component.scss']
})
export class PuestoVotacionComponent implements OnInit {
  public nuevoForm: FormGroup;
  public editForm: FormGroup;
  public nuevoFormUsuario: FormGroup;
  public isAuthLoading = false;


  public user: any = null;
  reporteExport: any;
  findInput: any;
  puestos: any = [];
  mesa_votacion: any = [];
  supervisor_votacion: any = [];
  listUsuarios: any = [];
  buscador: any;
  mesaId: any;
  perfilUsarioCrear: any;
  puestoId: any;
  pagesNumber: any;
  offset = 3;
  page = 1;
  public cargando = false;
  public editando = false;
  nombreMesa: any;
  sufragantesMesa: any;
  count_mesas: any;
  count_sufragantes: any;

  constructor(public router: Router, private toastr: ToastrService, private appService: AppService, private http: HttpClient) { }

  ngOnInit(): void {
    this.user = this.appService.user;
    this.getList();

    this.nuevoForm = new FormGroup({
      nombre: new FormControl(null, Validators.required),
      detalle: new FormControl(null, Validators.nullValidator),
    });

    this.editForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      nombre: new FormControl(null, Validators.required),
      detalle: new FormControl(null, Validators.nullValidator),
    });

    this.nuevoFormUsuario = new FormGroup({
      nombreUser: new FormControl(null, Validators.required),
      emailUser: new FormControl(null, Validators.required),
      passwordUser: new FormControl(null, Validators.required),
      celularUser: new FormControl(null, Validators.required),
      perfil_id: new FormControl(null, Validators.nullValidator),
    });


  }

  getList() {
    this.appService.getPuestoVotacion(this.user.et + '-' + this.page).subscribe((data) => {
      this.puestos = data['obj'];
      this.ForpagesNumber();
      this.cargando = false;
    });
  }

  changePage(page) {
    this.page = page; //para el filtro
    this.puestos.current = page;
    this.getList();
  }

  ForpagesNumber() {
    let from = this.puestos.current - this.offset;
    if (from < 1) {
      from = 1;
    }

    let to = from + (this.offset * 2);
    if (to >= this.puestos.total_page) {
      to = this.puestos.total_page;
    }

    let pagesArray = [];
    while (from <= to) {
      pagesArray.push(from);
      from++;
    }
    this.pagesNumber = pagesArray;
    // return pagesArray;
  }

  async new() {
    if (this.nuevoForm.valid) {
      this.isAuthLoading = true;
      let params = {
        nuevo: true,
        et: this.user.et,
        nombre: this.nuevoForm.value.nombre,
        detalle: this.nuevoForm.value.detalle,
        estado: 1,
      };
      // console.log(params);
      this.appService.postPuestoVotacion(params)
        .subscribe((data) => {
          // console.log(data);
          if (data["logger"] == true) {
            this.nuevoForm.reset()
            $('#offcanvasNuevaUsuario').offcanvas('hide');
            this.toastr.success(data["msg"]);
            this.getList();
          } else {
            this.toastr.error(data["msg"]);
          }
        });
      this.isAuthLoading = false;
    } else {
      this.toastr.error('El formulario no es válido!');
    }
  }


  ver(item) {
    this.editForm.get('id').setValue(item.id);
    this.editForm.get('nombre').setValue(item.nombre);
    this.editForm.get('detalle').setValue(item.detalle);
    this.count_mesas = item.count_mesas;
    this.count_sufragantes = item.count_sufragantes;

    $('#offcanvasVer').offcanvas('show');
    this.editando = false;
    this.getMesaVotacion(item.id);
    console.log(item);

  }


  getListUsuarios(perfil_id, puestoId, mesaId) {
    this.perfilUsarioCrear = perfil_id;
    // console.log(this.perfilUsarioCrear);

    this.mesaId = mesaId;
    this.puestoId = puestoId;
    let params = {
      get: true,
      et: this.user.et,
      perfil_id: perfil_id,
    };
    // console.log(params);
    this.appService.postUsuario(params)
      .subscribe((data) => {
        if (data["logger"] == true) {
          this.listUsuarios = data['obj'];
          // console.log(this.listUsuarios);          
        } else {
          this.toastr.error(data["msg"]);
        }
      });
  }

  async edit() {
    if (this.editForm.valid) {
      this.isAuthLoading = true;
      let params = {
        editar: true,
        id: this.editForm.value.id,
        nombre: this.editForm.value.nombre,
        detalle: this.editForm.value.detalle,
      };
      // console.log(params);
      this.appService.postPuestoVotacion(params)
        .subscribe((data) => {
          if (data["logger"] == true) {
            this.toastr.success(data["msg"]);
            this.editForm.reset()
            $('#offcanvasVer').offcanvas('hide');
            this.getList();
          } else {
            this.toastr.error(data["msg"]);
          }
        });
      this.isAuthLoading = false;
    } else {
      this.toastr.error('El formulario no es válido!');
    }
  }

  async eliminar(item) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `Desea eliminar este registro?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, estoy seguro!',
    }).then((result) => {
      if (result.value) {
        let params = {
          eliminar: true,
          id: item.id,
          empresa_id: this.user.eid
        }
        this.appService.postPuestoVotacion(params)
          .subscribe((data) => {
            if (data["logger"] == true) {
              this.getList();
              this.toastr.success(data["msg"]);
            } else {
              this.toastr.error(data["msg"]);
            }
          });

      }
    });

  }


  async find() {
    let params = {
      buscar: true,
      buscar_input: this.findInput,
      page: this.page,
      et: this.user.et,
    };
    this.appService.postPuestoVotacion(params)
      .subscribe((data) => {
        if (data["logger"] == true) {
          this.puestos = data['obj'];
        } else {
          this.toastr.error(data["msg"]);
        }
      });
  }


  crearUsuarioCard() {
    $('#nuevoUsuario').show();
  }

  async newUsuario() {
    if (this.nuevoFormUsuario.valid) {
      this.isAuthLoading = true;
      let params = {
        nuevo: true,
        nombre: this.nuevoFormUsuario.value.nombreUser,
        email: this.nuevoFormUsuario.value.emailUser,
        password: this.nuevoFormUsuario.value.passwordUser,
        celular: this.nuevoFormUsuario.value.celularUser,
        perfil_id: this.perfilUsarioCrear,
        estado: 1,
        empresa_id: this.user.eid
      };
      console.log(params);
      this.appService.postUsuario(params)
        .subscribe((data) => {
          if (data["logger"] == true) {
            this.nuevoFormUsuario.reset()
            $('#nuevoUsuario').hide();
            $('#buscarUsuarioModal').modal('hide');
            // this.getUsuarios();
            this.toastr.success(data["msg"]);
            console.log(data["obj"]);

            this.selectUsuarioMesa(data["obj"].id, data["obj"].perfil_id)
          } else {
            this.toastr.error(data["msg"]);
          }
        });
      this.isAuthLoading = false;
    } else {
      this.toastr.error('El formulario no es válido!');
    }
  }


  getMesaVotacion(id) {
    let params = {
      get: true,
      et: this.user.et,
      id: id,
      estado: 1,
    };
    // console.log(params);
    this.appService.postMesaVotacion(params)
      .subscribe((data) => {
        // console.log(data);
        if (data["logger"] == true) {
          this.count_mesas = data["count_mesas"];
          console.log(this.count_mesas);

          this.count_sufragantes = data["count_sufragantes"];
          this.mesa_votacion = data['obj'];
          this.supervisor_votacion = data['obj2'];
        } else {
          this.toastr.error(data["msg"]);
        }
      });
  }

  addMesaVotacion(id) {
    let params = {
      nuevo: true,
      et: this.user.et,
      puesto_id: id,
      nombre: 'mesa',
      estado: 1,
    };
    // console.log(params);
    this.appService.postMesaVotacion(params)
      .subscribe((data) => {
        // console.log(data);
        if (data["logger"] == true) {
          this.getMesaVotacion(id);
          this.getList();
        } else {
          this.toastr.error(data["msg"]);
        }
      });
  }

  selectUsuarioMesa(id, perfil_id) {
    let params = {
      nuevo: true,
      et: this.user.et,
      id: id,
      puesto_id: this.puestoId,
      mesa_id: this.mesaId,
      perfil_id: perfil_id,
      estado: 1,
    };
    // console.log(params);
    this.appService.postRelacionVotacion(params)
      .subscribe((data) => {
        // console.log(data);
        if (data["logger"] == true) {
          this.getMesaVotacion(this.puestoId);
          this.mesaId = null;
          this.puestoId = null;
          this.buscador = null;
          // this.mesa_votacion = data['obj'];
        } else {
          this.mesaId = null;
          this.puestoId = null;
          this.buscador = null;
          this.toastr.error(data["msg"]);
        }
      });
  }

  edicion(item) {
    this.editando = true;
    this.nombreMesa = item.nombre;
    this.sufragantesMesa = item.sufragantes;
    this.mesaId = item.id;
    this.puestoId = item.puesto_id;
  }

  actualizarMesa() {
    let params = {
      editar: true,
      et: this.user.et,
      id: this.mesaId,
      nombre: this.nombreMesa,
      sufragantes: this.sufragantesMesa,
    };
    console.log(params);
    console.log(this.puestoId);
    this.appService.postMesaVotacion(params)
      .subscribe((data) => {
        // console.log(data);
        if (data["logger"] == true) {
          this.getMesaVotacion(this.puestoId);
          this.getList();
          this.editando = false;
          this.toastr.success(data["msg"]);
        } else {
          this.toastr.error(data["msg"]);
        }
      });
  }

  eliminarMesa(idMesa, idPuesto) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `Desea eliminar esta mesa de votación?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, estoy seguro!',
    }).then((result) => {
      if (result.value) {
        let params = {
          eliminar: true,
          id: idMesa,
          puesto_id: idPuesto,
          empresa_id: this.user.eid
        }
        this.appService.postMesaVotacion(params)
          .subscribe((data) => {
            if (data["logger"] == true) {
              this.getMesaVotacion(idPuesto);
              this.getList();
              // this.getMesaVotacion(puestoId);
              this.toastr.success(data["msg"]);
            } else {
              this.toastr.error(data["msg"]);
            }
          });

      }
    });
  }
  eliminarTestigo(relacionId, puestoId) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `Desea eliminar este registro?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, estoy seguro!',
    }).then((result) => {
      if (result.value) {
        let params = {
          eliminar: true,
          id: relacionId,
          empresa_id: this.user.eid
        }
        this.appService.postRelacionVotacion(params)
          .subscribe((data) => {
            if (data["logger"] == true) {
              this.getMesaVotacion(puestoId);
              // this.toastr.success(data["msg"]);
            } else {
              this.toastr.error(data["msg"]);
            }
          });

      }
    });
  }


  getMapaVotacion(){
    let params = {
      getMapa:true,
      et: this.user.et,
    };
    // console.log(params);
    this.appService.postPuestoVotacion(params)
    .subscribe( (data) => {
        console.log(data);
        if (data["logger"] == true){
          
          // this.mesa_votacion = data['obj'];
          // this.supervisor_votacion = data['obj2'];
        }else{
            this.toastr.error(data["msg"]);
        }
    });
  }




}
